<script>
    import {PATH_PREFIX} from '../../apiUrls.js';

  import { onMount } from 'svelte';
  import BasicFormLayout from '../Form/BasicFormLayout.svelte';
  import Modal from '../Modal.svelte';
  import Button from '../Button.svelte';
  import yup, {object, string, number} from 'yup';
  import {validateForm} from '../Form/utils.js';
  import {submit} from '../Form/utils.js';
  import Errors from '../Errors.svelte';
  import {get} from '../../utils.js';
  import {sgettext} from '../../i18n.js';

  export let id = 'globalControlForm';
  export let title = sgettext('$$GLOBAL_CONTROL$$');
  export let iconOptionApi = `${PATH_PREFIX}/sw/api/icons/`;
  export let duplicateCheckApi = `${PATH_PREFIX}/sw/api/globalcontrol/check_duplicate/`;
  export let actionUrl = `${PATH_PREFIX}/sw/api/globalcontrol/`;
  export let editId = null;
  export let onSubmit = () => console.log('submitted')

  let duplicateCheckHardFail = false;

  let schema = object().shape({
    description: string().required(sgettext('$$REQUIRED_FIELD$$')),
    name: string()
          .required(sgettext('$$REQUIRED_FIELD$$'))
          .test(
              sgettext("$$DUPLICATE_1$$"),
              sgettext("$$CONTROL_NAME_ALREADY_EXISTS$$"),
              _ => !duplicateCheckHardFail,
          ),
    icon_id: number()
      .required(sgettext('$$REQUIRED_FIELD$$'))
      .typeError(sgettext('$$REQUIRED_FIELD$$'))
  });

  let iconOptions = [];
  let sending = false;
  let formErrors = [];
  let isValid = true;
  let controlNameBeforeEdit = '';

  let formModel = defaultFormModel();

  let fields = initialFields();

  async function getEditItem() {
    if (editId) {
      try {
        const response = await get(actionUrl + editId + '/');
        const json = await response.json();

        if (response.ok) {
          controlNameBeforeEdit = json.name;
          formModel = {
            name: json.name,
            description: json.description,
            icon_id: json.icon.id,
            ppe: json.ppe,
          };
        }
      } catch(error) {
        console.error(error);
      }      
    }
      duplicateCheckHardFail = false;
  }

  function initialFields() {
    return {
      name: {
        label: sgettext('$$NAME_2$$'),
        isValid: true,
        errors: null,
        handleChanged: validateWithoutSubmit,
        type: 'text',
        duplicateCheck: true,
        duplicateCheckApi: duplicateCheckApi,
        message: sgettext('$$SIMILAR_CONTROL_FOUND_1$$'),
        onCheck: handleDuplicate
      },
      ppe: {
        label: sgettext('$$PPE$$'),
        isValid: true,
        errors: null,
        type: 'checkbox',
      },
      description: {
        label: sgettext('$$DESCRIPTION_1$$'),
        isValid: true,
        errors: null,
        handleChanged: validateWithoutSubmit,
        type: 'text',
        multiline: true
      },
      icon_id: {
        label: sgettext('$$ICON_1$$'),
        isValid: true,
        errors: null,
        handleChanged: validateWithoutSubmit,
        type: 'select',
        searchable: true,
        options: []
      },
    }
  }

  function handleDuplicate(event){
    isValid = true;
    duplicateCheckHardFail = false;
    if(event.detail.length){
      if(event.detail[0].text !== controlNameBeforeEdit && event.detail[0].similarity === 100){
        isValid = false;
        duplicateCheckHardFail = true;
      }   
    }
  }

  function defaultFormModel(){
    return {
      description: '',
      icon_id: null, 
      name: ''
    }
  }

  async function getIcons(url) {
    const response = await get(url);
    const json = await response.json();

    if(response.ok) {
      iconOptions = json;
      fields.icon_id.options = json;
    }    
  }

  async function validateWithoutSubmit() {
    try{
      await validateForm(schema, formModel);
      isValid = true;

    } catch(err) {
      isValid = false;
      if(err.inner){
        err.inner.forEach(er => {
          fields[er.path].isValid = false;
          fields[er.path].errors = er.message;
        });
      }
    }
  }

  async function onSaveAndClose(){
    try{
      await validateForm(schema, formModel);  
      const response = await submitForm();  

      if(!formErrors || formErrors.length === 0){
        jQuery(`#${id}`).modal('hide');
        formModel = defaultFormModel();
        onSubmit();
      }
      
    } catch(err) {
      isValid = false;
      if(err.inner){
        err.inner.forEach(er => {
          fields[er.path].isValid = false;
          fields[er.path].errors = er.message;
        });
      }      
    }
  }

  async function onSaveAndCreate(){
    try{
      await validateForm(schema, formModel);
      const response = await submitForm();

      if(!formErrors || formErrors.length === 0){
        formModel = defaultFormModel();
      }

    } catch(err) {
      isValid = false;
      if(err.inner){
        err.inner.forEach(er => {
          fields[er.path].isValid = false;
          fields[er.path].errors = er.message;
        });
      }
    }
  }

  async function submitForm() {
    sending = true;
    let method = 'POST';
    let url = actionUrl;
    if(editId) {
      method = 'PATCH';
      url = actionUrl + editId + '/'
    }
    
    try {
      await submit(url, method, formModel);
    } catch(error) {
      if(error.hasOwnProperty('non_field_errors')) {
        formErrors = error.non_field_errors;
      } else {
        console.error(error);
      }
    } finally {
      sending = false;
    }
  }

  function handleClose(){
    formModel = defaultFormModel();
    isValid = true;
    sending = false;
    formErrors = null;
    fields = initialFields();
    fields.icon_id.options = iconOptions;
    editId = null;
  }

  onMount(async () => {
    await getIcons(iconOptionApi);

    jQuery(`#${id}`).on('show.bs.modal', function() {
      getEditItem();
    });

    jQuery(`#${id}`).on('hidden.bs.modal', function() {
      handleClose();
    });
  });
</script>

<style></style>

<Modal
  {id}
  {title}
  {isValid}
  large={true}
  backdrop={'static'}
>
  <div slot="body">
    <BasicFormLayout
      {id}
      {schema}
      {fields}
      {formModel}
     />
    {#if formErrors && formErrors.length > 0}
      <Errors errors={formErrors} />
    {/if}
  </div>

  <div slot="footer" class="footer">
    {#if !editId}
      <Button
        type="secondary"
        on:click={onSaveAndCreate}
        {sending}
        name={sgettext("$$SAVE_CREATE_ANOTHER$$")} />
    {/if}
    <Button
      type="primary"
      on:click={onSaveAndClose}
      {sending}
      name={sgettext("$$SAVE_CLOSE$$")} />
  </div>

</Modal>